import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from '../pages/Login';
import Usuarios from '../pages/Usuario';
import Clientes from '../pages/ClientesFidelizados';
import Entregadores from '../pages/Entregador';
import Horarios from '../pages/Horario';
import Pagamento from '../pages/Pagamento';
import Grupo from '../pages/Grupo';
import Produto from '../pages/Produto';
import Pedidos from '../pages/Pedido';
import ImprimirPedido from '../pages/ImprimirPedido/ImprimirPedido';
import Config from '../pages/Configuracoes';
import Bairro from '../pages/Bairro';
import Agendamento from '../pages/Agendamento';
import Empresa from '../pages/Empresa';
import Montagem from '../pages/Montagem';
import ConsultarPedidos from '../pages/ConsultarPedidos';
import ContasTransferencia from '../pages/ContasTransferencia';
import Regioes from '../pages/Regiao';
import CartaoVisita from '../pages/CartaoVisita';
import ImprimirCartaoVisita from '../pages/CartaoVisita/ImprimirCartao';
import Cupom from '../pages/Cupom';
import MensagensPersonalizadas from '../pages/Chatbot/MensagensPersonalizadas';
import Conexoes from '../pages/Chatbot/Conexoes';
import Templates from '../pages/Chatbot/Templates';
import TemplatesDeMensagens from '../pages/Chatbot/TemplatesDeMensagens';
import RelatorioVendas from '../pages/Relatorio/Vendas';
import ImprimirRelatorioVenda from '../pages/Relatorio/ImprimirRelatorioVenda';
import { useAuth } from '../hooks/auth';
import { usePermission } from '../hooks/usePermission';
import Menu from '../components/Menu';
import { TamanhosPizzas } from '../pages/TamanhosPizzas';
import { Loyalty } from '../pages/Loyalty';
import ServicosSolucoes from '../pages/ServicosSolucoes';
import RelatorioCuponsUtilizados from '../pages/Relatorio/CuponsUtilizados';
import ImprimirRelatorioCuponsUtilizados from '../pages/Relatorio/ImprimirCuponsUtilizados';
import RelatorioVendasEntregador from '../pages/Relatorio/VendasEntregador';
import ImprimirRelatorioVendasEntregador from '../pages/Relatorio/ImprimirVendasEntregador';
import Promocao from '../pages/Promocao';
import Banner from '../pages/Banner';
import Feriado from '../pages/Feriado';
import Avisos from '../pages/Avisos';
import SemAcesso from '../pages/SemAcesso';
import GruposAcesso from '../pages/GrupoAcesso';
import Avaliacoes from '../pages/Avaliacoes';
import ConsultarProdutos from '../pages/Relatorio/ConsultarProdutos';
import VendasFormaPagamento from '../pages/Relatorio/VendasFormaPagamento';
import VendasPorPeriodoHorario from '../pages/Relatorio/VendasPorPeriodoHorario';
import PaginaNaoEncontrada from '../pages/PaginaNaoEncontrada';
import Bloqueado from '../pages/Bloqueado';
import { GoogleTagManagerRouteTracker } from '../utils/googleTagManager';

const PrivateRoute = ({ component: Component, permissao, ...rest }) => {
  const { isAuth, user, bloqueio } = useAuth();
  const { can } = usePermission();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuth) {
          return (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          );
        }

        if (bloqueio) {
          return <Redirect to="/bloqueado" />;
        }

        if (permissao && !can(permissao)) {
          return <Redirect to="/sem-acesso" />;
        }

        const showMenu = user?.Id && rest.path !== '/g_imprimir_pedido/:id';

        return (
          <>
            {showMenu && <Menu />}
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <GoogleTagManagerRouteTracker />
      <Switch>
        <PrivateRoute
          path="/g_imprimir_pedido/:id"
          component={ImprimirPedido}
        />
        <PrivateRoute path="/g_avisos" component={Avisos} />
        <PrivateRoute
          path="/g_usuarios"
          component={Usuarios}
          permissao="usuarios"
        />
        <PrivateRoute
          path="/g_clientes"
          component={Clientes}
          permissao="fidelidade"
        />
        <PrivateRoute
          path="/g_entregadores"
          component={Entregadores}
          permissao="entregadores"
        />
        <PrivateRoute
          path="/g_configuracao"
          component={Config}
          permissao="configuracoes"
        />
        <PrivateRoute
          path="/g_horarios"
          component={Horarios}
          permissao="configuracoes"
        />
        <PrivateRoute
          path="/g_feriados"
          component={Feriado}
          permissao="configuracoes"
        />
        <PrivateRoute
          path="/g_pagamentos"
          component={Pagamento}
          permissao="configuracoes"
        />
        <PrivateRoute
          path="/g_grupoproduto"
          component={Grupo}
          permissao="cardapio"
        />
        <PrivateRoute
          path="/g_produtos"
          component={Produto}
          permissao="cardapio"
        />
        <PrivateRoute
          path="/g_pedidos"
          component={Pedidos}
          permissao="pedidos"
        />
        <PrivateRoute
          path="/g_contas"
          component={ContasTransferencia}
          permissao="empresa"
        />
        <PrivateRoute
          path="/g_consultarpedidos"
          component={ConsultarPedidos}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_consultarprodutos"
          component={ConsultarProdutos}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_vendasPorFormaPagamento"
          component={VendasFormaPagamento}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_vendasPorPeriodoHorario"
          component={VendasPorPeriodoHorario}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_bairro"
          component={Bairro}
          permissao="configuracoes"
        />
        <PrivateRoute path="/g_cupons" component={Cupom} permissao="cupons" />
        <PrivateRoute
          path="/g_fidelidade"
          component={Loyalty}
          permissao="fidelidade"
        />
        <PrivateRoute
          path="/g_promocao"
          component={Promocao}
          permissao="promocoes"
        />
        <PrivateRoute
          path="/g_banners"
          component={Banner}
          permissao="banners"
        />
        <PrivateRoute
          path="/g_empresa"
          component={Empresa}
          permissao="empresa"
        />
        <PrivateRoute path="/g_servicossolucoes" component={ServicosSolucoes} />
        <PrivateRoute
          path="/chatbot/templates-de-mensagens"
          component={TemplatesDeMensagens}
          permissao="chatbot"
        />
        <PrivateRoute
          path="/chatbot/mensagens-personalizadas"
          component={MensagensPersonalizadas}
          permissao="chatbot"
        />
        <PrivateRoute
          path="/chatbot/conexoes"
          component={Conexoes}
          permissao="chatbot"
        />
        <PrivateRoute
          path="/chatbot/templates"
          component={Templates}
          permissao="chatbot"
        />
        <PrivateRoute
          path="/g_montagem"
          component={Montagem}
          permissao="cardapio"
        />
        <PrivateRoute
          path="/g_tamanhos_pizza"
          component={TamanhosPizzas}
          permissao="cardapio"
        />
        <PrivateRoute
          path="/g_imprimir_cartao"
          component={ImprimirCartaoVisita}
          permissao="empresa"
        />
        <PrivateRoute
          path="/g_relatorio_vendas"
          component={RelatorioVendas}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_relatorio_cupons_utilizados"
          component={RelatorioCuponsUtilizados}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_relatorio_vendas_entregador"
          component={RelatorioVendasEntregador}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_imprimir_relatorio_vendas"
          component={ImprimirRelatorioVenda}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_imprimir_relatorio_cupons_utilizados"
          component={ImprimirRelatorioCuponsUtilizados}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_imprimir_relatorio_vendas_entregador"
          component={ImprimirRelatorioVendasEntregador}
          permissao="relatorios"
        />
        <PrivateRoute
          path="/g_agendamento"
          component={Agendamento}
          permissao="agendamento"
        />
        <PrivateRoute
          path="/g_regioes"
          component={Regioes}
          permissao="configuracoes"
        />
        <PrivateRoute
          path="/g_cartaovisita"
          component={CartaoVisita}
          permissao="empresa"
        />
        <PrivateRoute
          path="/g_grupos_acesso"
          component={GruposAcesso}
          permissao="usuarios"
        />
        <PrivateRoute
          path="/g_avaliacoes"
          component={Avaliacoes}
          permissao="relatorios"
        />
        <Route exact path="/sem-acesso" component={SemAcesso} />
        <Route exact path="/bloqueado" component={Bloqueado} />
        <Route exact path="/" component={Login} />
        <Route path="*" component={PaginaNaoEncontrada} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
